import React, { FC, useEffect, useRef } from 'react';

/** @jsx jsx */
import { css, jsx } from '@emotion/core';

import Prism from 'prismjs';
import './prism.css';
import { encodeCode } from '../../utils';
require('prismjs/components/prism-jsx.min');

interface Props
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  heading?: string;
  code?: string;
  language?: string;
}
export const Code: FC<Props> = ({ heading, code, language = 'markup' }) => {
  const rootDiv = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (rootDiv.current) {
      Prism.highlightAllUnder(rootDiv.current);
    }
  }, [code]);

  const styles = makeStyles({ heading });
  return (
    <div ref={rootDiv}>
      {heading && <div css={styles.heading}>{heading}</div>}
      {code && (
        <pre className={`language-${language}`} css={styles.code}>
          <code
            className={`language-${language}`}
            dangerouslySetInnerHTML={encodeCode(language)(code)}
          ></code>
        </pre>
      )}
    </div>
  );
};

const makeStyles = (options: any) => {
  return {
    heading: css`
      padding: 10px 0px 0px 15px;
      background-color: #272822;
      color: #666666;
      border-radius: 5px 5px 0px 0px;
      font-size: 12px;
      text-transform: uppercase;
    `,
    code: css`
      margin-top: 0px !important;
      padding: ${options.heading ? '5px 15px 15px 15px' : '15px'} !important;
      border-radius: ${options.heading ? '0px 0px 5px 5px' : '5px'} !important;
      font-size: 14px !important;
    `,
  };
};
